export default {
    slides:         state => state.slides,
    currentSlide:   state => state.current.slide,
    
    stories:        state => state.stories,
    currentStory:   state => state.current.story,

    storyGroup: (state) => (slug) => {
        const groupIndex = state.stories
            .findIndex(({ grouped = [] }) => {
                if ( !grouped ) {
                    return false
                }
                return grouped.some(
                    ([firstEl] = []) => firstEl && firstEl.slug === slug
                )
            })

        return groupIndex
    },
}